"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNotificationDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@goparrot/common");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const interface_1 = require("../interface");
class UpdateNotificationDto {
    constructor() {
        this.isEnabled = false;
    }
}
tslib_1.__decorate([
    (0, swagger_v4_1.ApiProperty)({ type: () => Boolean, default: false }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, class_validator_1.IsBoolean)({ always: true }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateNotificationDto.prototype, "isEnabled", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiProperty)({ type: () => String }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, class_validator_1.IsArray)({ always: true }),
    (0, class_validator_1.IsEmail)({}, { always: true, each: true }),
    tslib_1.__metadata("design:type", Array)
], UpdateNotificationDto.prototype, "emails", void 0);
exports.UpdateNotificationDto = UpdateNotificationDto;
//# sourceMappingURL=UpdateNotificationDto.js.map